module.exports = __webpack_public_path__ + "static/img/dasha.8347cbe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/team/dasha.png
// module id = lemH
// module chunks = 1